export class Room {
    Name: string;
    Address: string;
    Id: number;
    RoutingType: string;
    MailboxType: number;
}
